export default "__VITE_ASSET__B4UPKA9P__"